import { useEffect, useMemo, useState } from "react";
import { useCommunication } from "./CommunicationWrapper";
import { useAuthStep } from "@/hooks/useAuthStep";
import { getABBucket } from "./ab";

const experiments = {
    "upload_source_modal_v2": {
        buckets: 100
    }
}

export const useAuth = () => {

    const { token, setToken, completedSignup, setCompletedSignup, setAuthStep } = useAuthStep();
    const { useRerenderListener, sendMessage, authenticatedFetch, closeModal, updateOptions } = useCommunication();
    const { options } = useRerenderListener(["auth", "auth_state"]);

    console.log("sendMessage", sendMessage);

    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleLogout = () => {
        sendMessage({
            type: "CALL_EXTENSION_FUNC",
            payload: {
                func: "updateSettings",
                payload: {
                    "auth": null,
                }
            },
        });
    };

    // Compute A/B buckets for hard-coded experiments
    const abBucket = useMemo(() => Object.fromEntries(Object.entries(experiments).map(([exp, value] )=> [exp, getABBucket(options?.auth?.user.id, exp, value.buckets)])), [options?.auth?.user]) as Record<keyof (typeof experiments), number>

    return {
        authUser: options?.auth?.user,
        planType: options?.auth?.user?.app_metadata?.plan_type || "none",
        planEnd: options?.auth?.user?.app_metadata?.plan_end ?? null,
        token: options?.auth?.access_token,
        hasUsedTrial: options?.auth?.user?.app_metadata?.used_trial ?? false,
        handleLogout,
        abBucket,
    };
};
